import { AxiosResponse } from 'axios';
import { useAuthQuery } from 'features/common/apiUtils/graphQueryHelper';
import { UseQueryOptions } from 'react-query';
import { contextIdConfig } from '../config';
import { AvailableProduct } from '../types/types';

const {
  get_available_products: { url, queryKey, scope },
} = contextIdConfig;

export const useGetAvailableProducts = (
  queryOptions?:
    | Omit<
        UseQueryOptions<
          AxiosResponse<AvailableProduct[]>,
          unknown,
          AxiosResponse<AvailableProduct[]>,
          string[]
        >,
        'queryKey' | 'queryFn'
      >
    | undefined,
) =>
  useAuthQuery(
    queryKey,
    async (axiosInstance) => {
      return axiosInstance?.get<AvailableProduct[]>(url);
    },
    {
      ...queryOptions,
    },
    scope,
  );
